"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var PrefetchManager =
/** @class */
function () {
  function PrefetchManager(registered) {
    this.registered = new Set(registered);
  }

  PrefetchManager.prototype.register = function (registration) {
    var _this = this;

    this.registered.add(registration);
    return function () {
      return _this.registered.delete(registration);
    };
  };

  return PrefetchManager;
}();

exports.PrefetchManager = PrefetchManager;
exports.PrefetchContext = React.createContext(new PrefetchManager());